import React from 'react'
import Navbar from '../inc/Navbar'
import SareeTrending from './SareeTrending'

function Sareepage() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <SareeTrending/>
        <br/>
    </div>
  )
}

export default Sareepage